const TopBar = () => {
  return (
    <div className="top-bar">
      <div className="container">
        <span>Securing Progress Through Smart IT Solutions</span>
        <div className="pill-list">
          <a href="mailto:info@nexusitpk.com">info@nexusitpk.com</a>
          <a href="tel:+92515155854">+92 51 5155854</a>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
